import { MediaId, isMediaId, ContentId } from '~/src/common/media';

type Duration = { minutes: number; seconds: number };

type TEpisode = {
  id?: string;
  seasonNum?: number;
  episodeNum?: number;
  thumbnail?: { processed_url: string };
  media_duration?: Duration | null;
  title: string;
  description?: string | null;
  hero?: { processed_url: string } | null;
  media?: { brightcove_id: string | null } | null;
  trailer?: { brightcove_id: string | null } | null;
};

export class Episode {
  private episode: TEpisode;

  constructor(episode: TEpisode) {
    this.episode = episode;
  }

  description() {
    return this.episode.description ?? '';
  }

  heroImgSrc() {
    return this.episode.hero?.processed_url ?? '';
  }

  relativePathname(): string {
    return `${this.seasonNum()}/${this.episodeNum()}`;
  }

  id(): ContentId {
    const episodeId = this.episode.id;

    return episodeId as ContentId;
  }

  mediaId(): MediaId | null {
    const mediaId = this.episode?.media?.brightcove_id;

    if (isMediaId(mediaId)) {
      return mediaId;
    }
    return null;
  }
  thumbImgSrc(): string {
    return this.episode?.thumbnail?.processed_url ?? '';
  }
  title(): string {
    return this.episode.title;
  }
  trailerMediaId(): MediaId | null {
    const mediaId = this.episode?.trailer?.brightcove_id;

    if (isMediaId(mediaId)) {
      return mediaId;
    }
    return null;
  }

  mediaDuration(): Duration | null {
    return this.episode.media_duration ?? null;
  }
  episodeNum(): number {
    return this.episode.episodeNum ?? 0;
  }
  seasonNum(): number {
    return this.episode.seasonNum ?? 0;
  }

  data(): TEpisode {
    return this.episode;
  }
}
